"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasFormChanges = void 0;
require("react-final-form-hooks");
const hasFormChanges = (formApi, initialFormValues) => {
    const { values } = formApi.form.getState();
    const currentValues = JSON.stringify(values);
    const initialValues = JSON.stringify(initialFormValues);
    return currentValues !== '{}' && initialValues !== '{}' && initialValues !== currentValues;
};
exports.hasFormChanges = hasFormChanges;
//# sourceMappingURL=hasFormChanges.js.map